





























































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import Editor from '@tinymce/tinymce-vue';
import {SozlesmeEntity} from "@/entity/Sozlesme";

@Component({
    components: {
        DeleteButton,EForm,Number,TextField,Id,Editor
    }
})
export default class Sozlesmeler extends  Vue{
    items : SozlesmeEntity[] | null = null;
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = "sozlesme";
    action:string = this.baseAction;
    data : SozlesmeEntity = new SozlesmeEntity();
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "sozlesme_id"
        },
        {text: "Başlık", value: "name"},
        {text: "İşlemler", value: "actions"}
    ];
    edit(item:SozlesmeEntity){
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.sozlesme_id;
        this.dialog = true;
    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new SozlesmeEntity();
        this.dialog = true;
    }
    async get(){
        this.dialog = false;
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }
    created(){
        this.get();
    }
};
